const ACTIONS = {
    SELECT_NEXT: 'CAROUSEL/SELECT_NEXT',
    SELECT_PREV: 'CAROUSEL/SELECT_PREV',
    CHANGE_IMAGE_INDEX: 'CAROUSEL/CHANGE_IMAGE_INDEX',
    SET_FULL_SCREEN_STATE: 'CAROUSEL/SET_FULL_SCREEN_STATE',
    SET_VERTICAL_GALLERY_OPEN_STATE: 'CAROUSEL/SET_VERTICAL_GALLERY_OPEN_STATE'
};

const ACTION_CREATORS = {
    changeImageIndex(newIndex) {
        return {
            type: ACTIONS.CHANGE_IMAGE_INDEX,
            payload: {
                newIndex
            }
        };
    },

    selectNext(currentIndex, numImages) {
        return {
            type: ACTIONS.SELECT_NEXT,
            payload: {
                currentIndex,
                numImages
            }
        };
    },

    selectPrev(currentIndex, numImages) {
        return {
            type: ACTIONS.SELECT_PREV,
            payload: {
                currentIndex,
                numImages
            }
        };
    },

    setFullScreenState(newFullScreen = true) {
        return {type: ACTIONS.SET_FULL_SCREEN_STATE, payload: {
            newFullScreen
        }};
    },

    setVerticalGalleryOpenState: (payload = {isOpen: true}) =>
        ({type: ACTIONS.SET_VERTICAL_GALLERY_OPEN_STATE, payload})
};

export default {...ACTIONS, ...ACTION_CREATORS};
